import React, { useState } from 'react';
import './PropertyCard.css';
import { FaLocationArrow, FaHeart } from 'react-icons/fa';
import { assets } from '../../../assets/assets';
import moment from 'moment';
import Loader from '../Loader/Loader';
import { useSelector } from 'react-redux';
import { postData } from '../../../services/apiServices';
import toastService from '../../../services/toastService';

const PropertyCard = ({
    image,
    title,
    location,
    status,
    construction,
    type,
    propertyDescripiton,
    price,
    date,
    offerId,
    NoOfRooms,
    Area,
    is_fav,
    is_fav_id,
    District,
    handleClick
}) => {
    const [isLiked, setIsLiked] = useState(is_fav === 1);
    const [isLoading, setIsLoading] = useState(false)
    const userInfo = useSelector((state) => state.user.userInfo);

    const onClickHandler = () => {
        handleClick({
            image,
            title,
            location,
            status,
            construction,
            type,
            propertyDescripiton,
            price,
            date,
            offerId,
            NoOfRooms,
            Area,
            District,
            is_fav,
            is_fav_id
        });
    };

    const handleHeartClick = (e) => {
        e.stopPropagation();
        if (isLiked) {
            removeFromFavorite(offerId, is_fav_id);
        } else {
            addToFavorite(offerId, is_fav_id);
        }
        setIsLiked(!isLiked);
    };




    const addToFavorite = async (offerId) => {
        setIsLoading(true)
        const mydata = {
            "verification_token": "123456",
            "table": "fav_added",
            "offerid": offerId,
            "userid": userInfo?.id,
        };
        try {
            const result = await postData('/insert', mydata);
            if (result?.message === "success") {
                setIsLoading(false)
                toastService.showSuccess("Added to favorite");
            } else {
                setIsLoading(false)
                toastService.showError("Something went wrong");
            }
        } catch (error) {
            toastService.showError("Something went wrong");
            console.log(error);
            setIsLoading(false)

        } finally {
        }
        setIsLoading(false)

    };

    const removeFromFavorite = async (offerId, is_fav_id) => {
        setIsLoading(true)
        const mydata = {
            "verification_token": "123456",
            "table": "fav_added",
            "offerid": offerId,
            "userid": userInfo?.id,
            "id": is_fav_id
        };
        try {
            const result = await postData('/delete', mydata);
            if (result?.message === "success") {
                setIsLoading(false)
                toastService.showSuccess("Removed from favorite");
            } else {
                setIsLoading(false)
                toastService.showError("Something went wrong");
            }
        } catch (error) {
            setIsLoading(false)
            toastService.showError("Something went wrong");
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    };







    const pictures = image
        ? image.replace(/"/g, '').split(',')
        : [];
    const firstImage = pictures.length > 0 ? pictures[0] : '';

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="latest-property" onClick={onClickHandler}>
                <div className="property-header">

                    <FaHeart
                        color={isLiked ? 'red' : 'gray'}
                        size={30}
                        onClick={handleHeartClick}
                        style={{ cursor: 'pointer', marginRight: '10px' }}
                    />
                    <h3 className="property-title">{title}</h3>
                </div>
                <div className="property-location">
                    <FaLocationArrow className="location-icon" />
                    <p>{location}</p>
                </div>

                <div className='detail-row-style'>
                    <div className='inner-div-style'>
                        <h4>Offer Id</h4>
                        <p>{offerId}</p>
                    </div>

                    <div>
                        <h4>No of Rooms</h4>
                        <p>{NoOfRooms}</p>
                    </div>

                    <div>
                        <h4>Area</h4>
                        <p>{Area}</p>
                    </div>

                    <div>
                        <h4>District</h4>
                        <p>{location}</p>
                    </div>
                </div>

                <p>$ {price}</p>
                {/* 
            <div className='time-style-div'>
                <img className='clock-img-icon' src={assets.clockImg} alt="clock" />
                <p>{moment(date).format("ddd , MMM D , YYYY h:mm A")}</p>
            </div> */}
            </div>
        </>
    );
};

export default PropertyCard;
